import axios from 'axios';
import React, { useContext, useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import { ConfigContext } from '../Context/ConfigContext';
import { DateFormaterMonth } from '../Utils/GlobalFunction';

const Blog = () => {
    const { apiURL, apiHeaderJson } = useContext(ConfigContext);
    const [expandedId, setExpandedId] = useState(null);
    const [blogData, setBlogData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [limit] = useState(10);
    const [totalRecords, setTotalRecords] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [next, setNext] = useState(false);
    const [prev, setPrev] = useState(false);

    const getData = async (pageNumber = 1) => {
        try {
            setLoading(true);
            const headers = apiHeaderJson;
            const response = await axios.get(`${apiURL}Home/GetBlogs?page=${pageNumber}&limit=${limit}`, { headers });
            const { data, success, total_records, total_pages, page, next, prev } = response.data;

            if (success) {
                setBlogData(data);
                setNext(next);
                setPage(page);
                setPrev(prev);
                setTotalRecords(total_records);
                setTotalPages(total_pages);
            }
        } catch (error) {
            console.error("Error fetching blog data:", error);
        } finally {
            setLoading(false);
        }
    };

    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= totalPages) {
            setPage(newPage);
            getData(newPage);
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    };

    const toggleReadMore = (id) => {
        setExpandedId(expandedId === id ? null : id);
    };

    useEffect(() => {
        getData();
    }, []);

    return (
        <>
            <main className="main pages">
                <div className="page-header breadcrumb-wrap">
                    <div className="container">
                        <div className="breadcrumb">
                            <Link to="/" rel="nofollow">
                                <i className="fi-rs-home mr-5" /> Home
                            </Link>
                            <span /> Pages <span /> Blogs
                        </div>
                    </div>
                </div>

                <div className="page-content pt-50 pb-50">
                    <div className="container">
                        <h2>Our Blogs</h2>
                        {loading ? (
                            <div className="text-center py-5">
                                <div className="spinner-border text-primary" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        ) : (
                            <>
                                <div className="row mt-30">
                                    {blogData.map((item) => (
                                        <div className="col-md-3 mb-50" key={item.blog_id}>
                                            <div className="card h-100 border-0 overflow-hidden blog-animate">
                                                <div style={{ height: "200px", overflow: "hidden", borderRadius: "10px" }}>
                                                    <img
                                                        src={item.blog_image_url}
                                                        alt={item.blog_title}
                                                        style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                                    />
                                                </div>
                                                <div className="p-3 d-flex flex-column">
                                                    <h5 className="mb-2" style={{ minHeight: "3rem" }}>{item.blog_title}</h5>
                                                    <p
                                                        className="text-muted mb-0"
                                                        style={{
                                                            display: expandedId === item.blog_id ? "block" : "-webkit-box",
                                                            WebkitLineClamp: expandedId === item.blog_id ? "unset" : 3,
                                                            WebkitBoxOrient: "vertical",
                                                            overflow: "hidden",
                                                            textOverflow: "ellipsis",
                                                            flexGrow: 1,
                                                            minHeight: "1.5rem"
                                                        }}
                                                    >
                                                        {item.blog_description}
                                                    </p>
                                                    <span
                                                        className="p-0 text-decoration-underline"
                                                        style={{ fontSize: "0.9rem", cursor: "pointer", color: "#B76E79" }}
                                                        onClick={() => toggleReadMore(item.blog_id)}
                                                    >
                                                        {expandedId === item.blog_id ? "Read Less" : "Read More"}
                                                    </span>
                                                    <div className="mt-3">
                                                        <small className="text-muted text-end">Publish Date:- {DateFormaterMonth(item.blog_publish_date)}</small>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>

                                {/* Pagination */}
                                <div className="d-flex justify-content-center align-items-center mt-4">
                                    <div className="pagination-area" style={{ marginBottom: "30px" }}>
                                        <nav>
                                            <ul className="pagination justify-content-start">
                                                {/* Previous Button */}
                                                <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
                                                    <button
                                                        className="page-link"
                                                        onClick={() => handlePageChange(page - 1)}
                                                        disabled={page === 1}
                                                    >
                                                        <i className="fi-rs-arrow-small-left" />
                                                    </button>
                                                </li>

                                                {/* Page Numbers */}
                                                {[...Array(totalPages)].map((_, i) => {
                                                    const pageNumber = i + 1;
                                                    if (
                                                        pageNumber === 1 || // Always show first page
                                                        pageNumber === totalPages || // Always show last page
                                                        (pageNumber >= page - 1 && pageNumber <= page + 1) // Show pages around current
                                                    ) {
                                                        return (
                                                            <li
                                                                key={pageNumber}
                                                                className={`page-item ${page === pageNumber ? "active" : ""}`}
                                                            >
                                                                <button
                                                                    className="page-link"
                                                                    onClick={() => handlePageChange(pageNumber)}
                                                                >
                                                                    {pageNumber}
                                                                </button>
                                                            </li>
                                                        );
                                                    }
                                                    return null;
                                                })}

                                                {/* Next Button */}
                                                <li className={`page-item ${page === totalPages ? "disabled" : ""}`}>
                                                    <button
                                                        className="page-link"
                                                        onClick={() => handlePageChange(page + 1)}
                                                        disabled={page === totalPages}
                                                    >
                                                        <i className="fi-rs-arrow-small-right" />
                                                    </button>
                                                </li>
                                            </ul>
                                        </nav>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </main>
        </>
    )
}

export default Blog;